import React from "react";
import { ArrowRight } from "lucide-react";

export default function StickyOrderBar({ count, total, onCheckout }) {
    if (count === 0) return null;
    return (
        <div
            data-testid="sticky-order-bar"
            className="fixed left-1/2 bottom-5 z-40 w-[min(96%,560px)] -translate-x-1/2 animate-slide-up"
        >
            <div className="flex items-center justify-between gap-3 bg-white rounded-full pl-5 pr-2 py-2 shadow-[0_14px_48px_rgba(13,40,24,0.22)] border border-mint">
                <div className="min-w-0">
                    <p className="text-[11px] uppercase tracking-widest text-muted2 font-bold">
                        Your Order
                    </p>
                    <p className="text-sm sm:text-base font-bold text-navy truncate">
                        {count} {count === 1 ? "meal" : "meals"} ·{" "}
                        <span className="font-display text-forest text-lg sm:text-xl">
                            ${total.toFixed(2)}
                        </span>
                    </p>
                </div>
                <button
                    data-testid="sticky-checkout-btn"
                    onClick={onCheckout}
                    className="group flex items-center gap-2 bg-gold hover:bg-goldDark text-navy font-bold rounded-full px-5 py-3 transition-all active:scale-95 shadow-md"
                >
                    Checkout
                    <ArrowRight
                        size={18}
                        className="group-hover:translate-x-0.5 transition-transform"
                    />
                </button>
            </div>
        </div>
    );
}
